import React, { useEffect } from "react";
import HeaderMobile from "../../admin/layouts/HeaderMobile";
import Header from "../../admin/layouts/Header";
import TopMenu from "./TopMenu";
import Footer from "../../admin/layouts/Footer";
import Scrolltop from "../../admin/layouts/Scrolltop";
import UserProfile from "../../admin/layouts/UserProfile";
import { useState } from "react";
import { UserManagementService } from "../../../service/user_management/user_management.service";
import Spinner from "../../Spinner";
import Sidebar from "./Sidebar";
import "./layouts.css";

export default function Template(props) {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  useEffect(() => {
    if (window.KTLayoutAsideMenu)
      window.KTLayoutAsideMenu.init("kt_aside_menu");
    if (window.KTLayoutQuickUser)
      window.KTLayoutQuickUser.init("kt_quick_user");
    if (window.KTLayoutAsideToggle)
      window.KTLayoutAsideToggle.init("kt_aside_toggle");
    let isAdmin = sessionStorage.getItem("userType") === "admin";
    let isTeacher = sessionStorage.getItem("userType") === "teacher";
    let isStudent = sessionStorage.getItem("userType") === "student";
    let isParent = sessionStorage.getItem("userType") === "parent";
    setIsAdmin(isAdmin);
    setIsTeacher(isTeacher);
    setIsStudent(isStudent);
    setIsParent(isParent)
  }, []);
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isTeacher, setIsTeacher] = useState(false);
  const [isStudent, setIsStudent] = useState(false);
  const [isParent, setIsParent] = useState(false);

  const onLogout = async () => {
    setLoading(true);
    await UserManagementService.logout();
    setLoading(false);
  };
  if (loading) {
    return <Spinner active={true} text="Logging Out..." />;
  } else {
    return (
      <>
        <HeaderMobile onMobileMenuToggle={() => setIsMobileSidebarOpen((prev) => !prev)} />
        <Header />
        <div className="d-flex flex-column flex-root">
          <div className="d-flex flex-row flex-column-fluid page">
            <Sidebar
              isAdmin={isAdmin}
              isTeacher={isTeacher}
              isStudent={isStudent}
              isParent={isParent}
              isMobileOpen={isMobileSidebarOpen}
              onMobileClose={() => setIsMobileSidebarOpen(false)}
              onToggle={(expanded) => setSidebarExpanded(expanded)}
            />
            <div
              className={`d-flex flex-column flex-row-fluid wrapper ${sidebarExpanded ? 'sidebar-expanded' : ''}`}
              id="kt_wrapper"
            >
              <div className="content flex-grow-1">
                {props.children}
              </div>
              <Footer />
            </div>
          </div>
        </div>
        <Scrolltop />
        <UserProfile isMobileView={false} />

      </>
    );
  }
}
